import React, { Component } from "react";
import Title from "./Title";
import { ProductContext } from "../context";
import Product from "./Product";
import Loading from "./Loading";
export default class FeaturedProducts extends Component {
  static contextType = ProductContext;

  render() {
    let { loading, featuredProducts: products } = this.context;

    products = products.map(product => {
      return <Product key={product.id} product={product} />;
    });
    return (
      <section className="featured-products">
        <Title title="featured products" />
        <div className="featured-products-center">
          {loading ? <Loading /> : products}
        </div>
      </section>
    );
  }
}
